export default __webpack_public_path__ + "da522896c351cca41e3df6b9ef558702.png";